import { InjectionToken } from "@angular/core";

export interface GUIConfiguration {
    theme: string;
    language: string;
}

export const GUI_CONFIG = new InjectionToken<GUIConfiguration>('movisat.common-gui.config');